import { useEffect, useState } from 'react';
import { Button, Dialog, Flex, Icon } from '@gravity-ui/uikit';
import { Printer } from '@gravity-ui/icons';
import { useTranslation } from 'react-i18next';
import { LoadingState } from '@/shared/ui/states';
import type { JournalDoc } from './journal-print';

/**
 * Предпросмотр заполненного журнала: тот же PDF, что уходит в печать,
 * встроенный в окно. «Печать» скачивает именно этот документ — без
 * повторного сбора данных.
 */
export function JournalPreviewDialog({
  open,
  title,
  journalDoc,
  onClose,
}: {
  open: boolean;
  title: string;
  /** null — документ ещё собирается. */
  journalDoc: JournalDoc | null;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!journalDoc) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(journalDoc.doc.output('blob'));
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [journalDoc]);

  return (
    <Dialog open={open} onClose={onClose} className="journal-preview">
      <Dialog.Header caption={title} />
      <Dialog.Body className="journal-preview__body">
        {url ? (
          <iframe
            className="journal-preview__frame"
            src={`${url}#view=FitH&navpanes=0`}
            title={title}
          />
        ) : (
          <LoadingState />
        )}
      </Dialog.Body>
      <Dialog.Footer>
        <Flex justifyContent="flex-end" gap={2} style={{ width: '100%' }}>
          <Button view="outlined" size="l" onClick={onClose}>
            {t('journals.close')}
          </Button>
          <Button
            view="action"
            size="l"
            disabled={!journalDoc}
            onClick={() => journalDoc?.doc.save(journalDoc.fileName)}
          >
            <Icon data={Printer} size={16} />
            {t('journals.print')}
          </Button>
        </Flex>
      </Dialog.Footer>
    </Dialog>
  );
}
